<script setup lang="ts">
import Card, { type CardProps } from "./Card.vue";

const props = defineProps<CardProps>();
</script>

<template>
	<Card class="soft-card" v-bind="props">
		<slot />
	</Card>
</template>
